import { Trans } from 'next-i18next';
import type { ImageSearchProvider } from '../types/imageSearch.types';
export const SearchDefaultScreen = ({
  provider = 'pexels',
  onLinkClick
}: {
  provider?: ImageSearchProvider;
  onLinkClick?: () => void;
}) => {
  if (provider === 'naver') {
    return <div className="flex size-full flex-col items-center justify-between px-[24px] pb-[32px] pt-[80px]">
        <div className="py-[64px]">
          <a href="https://www.naver.com" target="_blank" rel="noopener noreferrer" onClick={onLinkClick}>
            <img src="/assets/naver_logo.webp" alt="Naver Logo" className="w-[220px]" />
          </a>
        </div>
        <div className="text-body-md-medium text-[#9E9FAF]">
          <Trans i18nKey="build:image.naverTab.footer" components={{
          anchor: <a href="https://policy.naver.com/policy/service.html" className="text-[#0D94FF]" target="_blank" rel="noopener noreferrer" onClick={onLinkClick} />
        }} />
        </div>
      </div>;
  }
  return <div className="flex size-full flex-col items-center justify-between pb-xl pt-4xl" data-sentry-component="SearchDefaultScreen" data-sentry-source-file="SearchDefaultScreen.tsx">
      <a href="https://www.pexels.com" target="_blank" rel="noopener noreferrer" className="my-xl" onClick={onLinkClick}>
        <img src="/assets/pexels_logo.webp" alt="Pexels Logo" className=" w-[220px] opacity-10" />
      </a>
      <div className="text-body-md-medium text-[#9E9FAF]">
        <Trans i18nKey="build:image.searchTab.footer" components={{
        anchor: <a href="https://www.pexels.com/license/" className="text-link" target="_blank" rel="noopener noreferrer" onClick={onLinkClick} />
      }} data-sentry-element="Trans" data-sentry-source-file="SearchDefaultScreen.tsx" />
      </div>
    </div>;
};